import React from "react";
import { Link } from "react-router-dom";

// components
import TopBar from "../../components/MonitorComponents/TopBar";
import MessageBox from "../../components/MonitorComponents/MessageBox";
import PatientDemo from "../../components/MonitorComponents/PatientDemo";

//styles 
import { LandScapeContainer } from "./LandScapePage.elements";
import { ReviewAlarmsContainer } from "./ReviewAlarms.elements";
import {
  SettingsTopLine,
  SettingsBack1,
  SettingsClose,
} from "../../components/Settings/SettingBar.elements";

//images
import reviewAlarms from "../../img/misc/reviewalarms.png";


// icons
import { AiOutlineClose } from "react-icons/ai";
import {
  MdOutlineArrowBackIosNew,
} from "react-icons/md";




const ReviewAlarms = () => {

  function handleBackButtonClick() {
    const scrollPosition = window.pageYOffset;
    window.history.back();
    setTimeout(() => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          window.scrollTo(0, element.offsetTop);
        }
      } else {
        window.scrollTo(0, scrollPosition);
      }
    }, 0);
  }

  return (
    <LandScapeContainer>
      <TopBar />
      <MessageBox landscape />
      <PatientDemo />
      <SettingsTopLine>
        Review Alarms
        <SettingsBack1 onClick={handleBackButtonClick}>
          <MdOutlineArrowBackIosNew></MdOutlineArrowBackIosNew>
        </SettingsBack1>
        <Link to="/">
          <SettingsClose>
            <AiOutlineClose></AiOutlineClose>
          </SettingsClose>
        </Link>
      </SettingsTopLine>

      <ReviewAlarmsContainer>
        <img src={reviewAlarms} alt="" />
      </ReviewAlarmsContainer>
    </LandScapeContainer>
  );
};

export default ReviewAlarms;
